import { createStore } from 'vuex'
import { userinfo } from '@/utils/api'

let timer = null

export default createStore({
  state: {
    loading: false,
    oss_client_config: null,
    userInfo: null,
    indexData: null,
    audioPlaying: null,
  },
  getters: {},
  mutations: {
    loading(state, payload = false) {
      state.loading = payload
    },
    oss_client_config(state, payload = {}) {
      state.oss_client_config = payload
    },
    userInfo(state, payload = {}) {
      state.userInfo = payload
    },
    indexData(state, payload = {}) {
      state.indexData = payload
    },
    audioPlaying(state, payload = {}) {
      state.audioPlaying = payload
    },
  },
  actions: {
    loading({ commit }, payload = false) {
      clearTimeout(timer)
      if (payload) {
        commit('loading', payload)
      } else {
        timer = setTimeout(() => {
          commit('loading', payload)
        }, 500)
      }
    },
    async userInfo({ commit }, payload = {}) {
      const { data: res } = await userinfo(payload.fields, payload.config)
      commit('userInfo', res.data)
    },
  },
  modules: {},
})
